import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import PackingForm from "../packingForm/packingForm";

export default class AddPacking extends React.Component {
    render() {
        return (
            <AddItem
                class="add-packing"
                header={i18n.t("dictionaries.packing.actions.addPacking.header")}
                content={<PackingForm isUpdate={false} />}
            />
        );
    }
}